<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="70%"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <ChooseOrderGoods
      ref="chooseOrderGoodsInner"
      :type="type"
      :height="height"
      :baseInfo="baseInfo"
      :checkedCount="checkedCount"
      @chooseChange="chooseChange"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        :disabled="!checkedCount"
        @click="confirm()"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import ChooseOrderGoods from './index.vue'
export default {
  components: { ChooseOrderGoods },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    type: { type: String, default: 'radio' },
    height: { type: Number, default: 500 },
    baseInfo: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      checkedRow: null,
    }
  },
  computed: {
    checkedCount() {
      if (this.multiple) {
        return !this.checkedRow ? 0 : this.checkedRow.length
      }
      return this.checkedRow ? 1 : 0
    },
  },
  methods: {
    confirm() {
      if (!this.checkedCount) return
      this.$emit('confirm', this.checkedRow)
      this.close()
    },
    chooseChange(data) {
      this.checkedRow = data
    },

    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
